<script setup lang="ts">
definePageMeta({
  name: "article",
  layout: "article",
})

const productContent = useProductContentStore()
const personalization = usePersonalizationStore()

watch(
  () => productContent.activeArticle,
  () => {
    personalization.activeArticle = productContent.activeArticle
  },
  { immediate: true },
)

onUnmounted(() => {
  personalization.activeArticle = undefined
})
</script>

<template>
  <div>
    <u-dynamic-article
      v-if="productContent.activeArticle"
      :data="productContent.activeArticle"
    />
    <div class="fixed right-0 top-0">
      <u-feature-flag>
        <div
          class="bg-platform-paper font-national2compressed text-sm text-black"
        >
          {{ personalization.elapsedSeconds }} s
        </div>
      </u-feature-flag>
    </div>
  </div>
</template>
